import { render } from "./PhoneCode.vue?vue&type=template&id=4be07ba6"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"

import "./PhoneCode.vue?vue&type=style&index=0&id=4be07ba6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__